import $ from "jquery";
import "slick-carousel";
import slickCss from "slick-carousel/slick/slick.css";

const domElements = {};

function initDomElements() {
  //  domElements.main = $(".product-single-slider");
  domElements.main = $(".hero-slider");
  domElements.slider = $(".hero-slider__items");
  domElements.togglePlay = domElements.main.find(".hero-slider__toggle-play");
  domElements.toggleButton = domElements.main.find(".hero-slider__toggle-button");
  if (domElements.main.length < 1) return false;
  return true;
}

function initTogglePlayButton() {

  domElements.toggleButton.on('click', function() {
    const isPlaying = domElements.toggleButton.hasClass('hero-slider__toggle-button--playing');

    if (isPlaying) {

      domElements.slider.slick('slickPause');
      domElements.toggleButton.removeClass('hero-slider__toggle-button--playing');
      domElements.toggleButton.addClass('hero-slider__toggle-button--paused');
      domElements.toggleButton.attr('aria-label', 'Play');
    } else {

      domElements.slider.slick('slickPlay');
      domElements.toggleButton.removeClass('hero-slider__toggle-button--paused');
      domElements.toggleButton.addClass('hero-slider__toggle-button--playing');
      domElements.toggleButton.attr('aria-label', 'Pause');
    }
  });
}

function heroSlider() {
  if (!initDomElements()) {
    return false;
  }

  domElements.slider.slick({
    // cssEase: "linear",
    dots: true,
    appendDots: $(".hero-slider__dots"),
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $(".hero-slider__arrow--prev"),
    nextArrow: $(".hero-slider__arrow--next"),
    rows: 0,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 5100,
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false
  });

  initTogglePlayButton();
}

export default heroSlider;
